import { FC, Fragment } from 'react';

import ReactMarkdown from 'react-markdown';
import { addOrDelete } from 'utils/clickme';

import Checkbox from 'bloko/blocks/checkbox';
import FormItem from 'bloko/blocks/form/FormItem';
import Radio from 'bloko/blocks/radio';
import VSpacing from 'bloko/blocks/vSpacing';

import { type Answer, type Question as QuestionType, QuizQuestionType } from 'store/models/quiz';

interface QuestionProps extends QuestionType {
    currentAnswer: Answer;
    setAnswer: (newAnswer: Answer) => void;
}

const Question: FC<QuestionProps> = ({ text, answerType, answerOptions, currentAnswer, setAnswer }) => (
    <Fragment>
        <ReactMarkdown linkTarget="_blank">{text}</ReactMarkdown>
        <VSpacing base={2} />
        {answerOptions.map(({ id: answerId, answerOptionText }) => {
            const checked = currentAnswer.includes(answerId.toString());
            return (
                <FormItem key={answerId} baseline>
                    {answerType === QuizQuestionType.Checkbox && (
                        <Checkbox
                            value={answerId}
                            onChange={(event) => {
                                const newAnswer = addOrDelete(currentAnswer, event.target.value, event.target.checked);
                                setAnswer(newAnswer);
                            }}
                            checked={checked}
                        >
                            <ReactMarkdown linkTarget="_blank">{answerOptionText}</ReactMarkdown>
                        </Checkbox>
                    )}
                    {answerType === QuizQuestionType.Radio && (
                        <Radio
                            name="question"
                            value={answerId}
                            onChange={(event) => {
                                setAnswer([event.target.value]);
                            }}
                            checked={checked}
                        >
                            <ReactMarkdown linkTarget="_blank">{answerOptionText}</ReactMarkdown>
                        </Radio>
                    )}
                </FormItem>
            );
        })}
    </Fragment>
);

export default Question;
